import { Component, Input, OnInit } from '@angular/core';

export const directionPathMap = {
  left: 'M26 0 l-25 25 l50 50',
  right: 'M0 0 l24 25 l-50 50',
  up: 'tbc',
  down: 'tbc'
};

@Component({
  selector: 'sa-chevron',
  templateUrl: './chevron.component.html',
  styleUrls: ['./chevron.component.scss']
})
export class ChevronComponent implements OnInit {
  @Input()
  direction = 'right';

  directionPath = 'M0 0';

  constructor() { }

  ngOnInit(): void {
    const directionInput = this.direction ? directionPathMap[this.direction] : directionPathMap['left'];
    this.directionPath = directionInput;
  }

}